import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useBrand } from '../../app/config/brand';
import { useSessionExpiry } from '../contexts/SessionExpiryContext';

const SessionExpiryModal: React.FC = () => {
  const { isExpired } = useSessionExpiry();
  const { loginWithRedirect } = useAuth0();
  const brand = useBrand();

  if (!isExpired) return null;

  const handleLogin = () => {
    loginWithRedirect({
      appState: { returnTo: window.location.pathname + window.location.search },
    });
  };

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4"
      data-testid="session-expiry-modal"
    >
      {/* Backdrop — no onClick: the only exit is re-authentication */}
      <div className="absolute inset-0 bg-black/50" />

      {/* Card */}
      <div
        className="relative rounded-xl shadow-2xl w-full max-w-sm p-8 flex flex-col items-center text-center"
        style={{ backgroundColor: brand.colors.bgCard }}
      >
        <h2
          className="text-xl font-semibold mb-3"
          style={{ color: brand.colors.secondary }}
        >
          Your session has expired
        </h2>

        <p
          className="text-sm mb-6"
          style={{ color: brand.colors.textLight }}
        >
          For your security, you have been signed out. Please log in again to
          continue where you left off.
        </p>

        <button
          onClick={handleLogin}
          className="px-8 py-2.5 text-sm font-medium rounded-full transition-all duration-200"
          style={{ backgroundColor: brand.colors.primary, color: brand.colors.onPrimary }}
        >
          Log In
        </button>
      </div>
    </div>
  );
};

export default SessionExpiryModal;
